import { render, staticRenderFns } from "./SystemApi.vue?vue&type=template&id=55075037&scoped=true&"
import script from "./SystemApi.vue?vue&type=script&lang=js&"
export * from "./SystemApi.vue?vue&type=script&lang=js&"
import style0 from "./SystemApi.vue?vue&type=style&index=0&id=55075037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55075037",
  null
  
)

export default component.exports